import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../../theme';
import { responsiveMdVsLg } from '../../../styles/responsiveMixins';

export const useReleaseShipmentFormsStyles = createStyles(({ token }) => ({
  card: {
    border: `2px solid ${token.colorWhite}`,
    backgroundColor: ThemeColors.COLOR_WHITE2,
    borderRadius: token.borderRadiusSM,
    paddingBottom: ThemeSpaces.SPACE_NORM_15,
    boxShadow: `4px 4px 20px ${ThemeColors.COLOR_GREY8_1}`,

    '> .ant-row': {
      rowGap: `${ThemeSpaces.SPACE_NORM_20}px !important`,
    },

    ...responsiveMdVsLg(
      { padding: ThemeSpaces.SPACE_NORM },
      {
        padding: `${ThemeSpaces.SPACE_MD}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_20}px`,
      }
    ),

    '.JobLocationCard-Section .JobLocationCard-SectionTitle': {
      color: ThemeColors.COLOR_GREY3,
    },
  },
  dividerCol: {
    paddingBottom: ThemeSpaces.SPACE_NORM,
  },
}));
